/*=========================================================================================
  File Name: gameModule.js
  Description: game Module
==========================================================================================*/


import state from './gameState'
import mutations from './gameMutations'
import actions from './gameActions'
import getters from './gameGetters'


export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
}
